// Tekster for pipeline pakke 4 (Vunnet-dialogen, linjer, utkast og gjenåpning fra vunnet). Egen fil så delene av pakken kan
// bygges hver for seg.
export const norwegianPipelineWonMessages = {
  crm: {
    deals: {
      won: {
        title: "Marker som vunnet",
        description: "Gratulerer! Sjekk tallene, så ordner Mimin resten.",
        confirm: "Marker som vunnet",
        shortcut_hint: "Ctrl/⌘ + Enter bekrefter",
        agreement: "Avtalen",
        customer: "Kunde",
        customer_search: "Søk etter kunde …",
        customer_none: "Ingen treff",
        customer_required:
          "Velg eller opprett en kunde. En vunnet mulighet må ha en kunde.",
        change_customer: "Bytt kunde",
        create_customer: "Opprett kunde",
        new_customer: "Ny kunde",
        choose_existing: "Velg eksisterende kunde",
        kind: "Kundetype",
        kind_business: "Bedrift",
        kind_private: "Privat",
        the_customer: "kunden",
        lines_required: "Legg til minst én produktlinje.",
        one_time: "Engangsbeløp (eks. mva)",
        monthly: "Månedlig beløp (eks. mva)",
        override: "Overstyr",
        override_cancel: "Bruk summen av linjene",
        override_amount: "Nytt engangsbeløp",
        override_reason: "Begrunnelse",
        override_reason_required: "Skriv hvorfor engangsbeløpet er overstyrt.",
        binding: "Bindingstid",
        binding_none: "Ingen",
        binding_months: "%{smart_count} mnd",
        subscription_start: "Abonnement fra",
        won_date: "Vunnet dato",
        acceptance: "Akseptert via",
        acceptance_methods: {
          signed: "Signert avtale",
          email: "E-post",
          verbal: "Muntlig",
          order: "Ordre",
        },
        win_reason: "Vinnårsak",
        summary_first_year: "Første år: %{total} kr",
        summary_binding: "Over bindingstiden (%{months} mnd): %{total} kr.",
        startup: "Oppstart",
        project_lead: "Prosjektansvarlig",
        template: "Prosjektmal",
        template_none: "Ingen mal",
        planned_start: "Planlagt oppstart",
        planned_launch: "Planlagt lansering",
        org_nr: "Org.nr.",
        org_nr_invalid: "Org.nr. må ha 9 siffer.",
        invoice_email: "Fakturae-post",
        manual_billing:
          "Engangsbeløpet faktureres manuelt etter avtale med kunden. Mimin lager ingen faktura eller fakturagrunnlag for det.",
        next: "Hva skjer nå",
        action_customer: "Gjør %{name} til kunde",
        action_project:
          "Opprett prosjekt fra malen «%{template}» med %{smart_count} oppstartsoppgave |||| Opprett prosjekt fra malen «%{template}» med %{smart_count} oppstartsoppgaver",
        action_project_plain: "Opprett prosjekt uten mal",
        action_subscription: "Legg abonnementet på kunden som kundeprodukt",
        no_recurring: "Ingen gjentakende linjer.",
        action_handover: "Lag overleveringsoppgave til",
        billing_owner: "Fakturaansvarlig",
        action_thanks: "Lag takkemelding til %{name}",
        action_thanks_plain: "Lag takkemelding",
        no_contact: "Muligheten har ingen kontaktperson.",
        action_review: "Be om anmeldelse 14 dager etter lansering",
        action_notify: "Varsle teamet",
        notify_who: "Hvem skal varsles?",
        open_tasks: "Åpne oppgaver (%{smart_count})",
        open_tasks_move: "Flytt til prosjektet",
        open_tasks_complete: "Marker som fullført",
        open_tasks_keep: "Behold",
        one_at_a_time: "Marker én mulighet som vunnet om gangen.",
        done: "%{name} er markert som vunnet.",
        undo: "Angre",
        undone: "Angret. Muligheten er åpen igjen.",
        undo_too_late: "For sent å angre – åpne muligheten og gjenåpne den",
        project_failed: "Prosjektet ble ikke opprettet.",
        automation_failed: "Noen automasjoner etter salget feilet.",
      },
      lines: {
        title: "Produktlinjer",
        product: "Produkt",
        description: "Beskrivelse",
        quantity: "Antall",
        price: "Pris",
        interval: "Periode",
        intervals: {
          one_time: "engangs",
          monthly: "månedlig",
          quarterly: "kvartalsvis",
          yearly: "årlig",
        },
        row_label: "%{field} (linje %{n})",
        choose_product: "Velg produkt …",
        remove: "Fjern linje %{n}",
        add: "Legg til produkt",
        edit: "Rediger linjer",
        save: "Lagre linjer",
        saved: "Produktlinjene er lagret",
        empty: "Ingen produktlinjer ennå.",
        product_required: "Velg et produkt fra produktkatalogen på hver linje.",
      },
      drafts: {
        title: "E-postutkast",
        open: "Åpne i e-post",
        copy: "Kopier tekst",
        copied: "Teksten er kopiert",
        copy_failed: "Kunne ikke kopiere teksten",
        sent_question: "Sendte du e-posten?",
        log_yes: "Ja, logg som kontakt",
        not_yet: "Ikke ennå",
        logged: "Logget som kontakt: %{title}",
        to: "Til %{email}",
        no_recipient: "Ingen mottaker – legg den til i e-postprogrammet.",
      },
      reopen: {
        won_footprint:
          "Ved salget ble det opprettet %{items}. Hva vil du gjøre?",
        won_projects: "%{smart_count} prosjekt |||| %{smart_count} prosjekter",
        won_tasks: "%{smart_count} oppgave |||| %{smart_count} oppgaver",
        won_subscriptions:
          "%{smart_count} abonnement |||| %{smart_count} abonnementer",
        and: "og",
        won_project: "Prosjekt",
        won_products: "Abonnement som ikke er fakturert",
        keep: "Behold",
        archive: "Arkiver",
        deactivate: "Deaktiver",
        won_invoiced:
          "Abonnementet er fakturert for %{smart_count} måned. Kreditnota må lages i Tripletex. |||| Abonnementet er fakturert for %{smart_count} måneder. Kreditnota må lages i Tripletex.",
      },
    },
  },
};

export const englishPipelineWonMessages = {
  crm: {
    deals: {
      won: {
        title: "Mark as won",
        description:
          "Congratulations! Check the numbers and Mimin does the rest.",
        confirm: "Mark as won",
        shortcut_hint: "Ctrl/⌘ + Enter confirms",
        agreement: "The agreement",
        customer: "Customer",
        customer_search: "Search for a customer …",
        customer_none: "No matches",
        customer_required:
          "Choose or create a customer. A won opportunity must have a customer.",
        change_customer: "Change customer",
        create_customer: "Create customer",
        new_customer: "New customer",
        choose_existing: "Choose an existing customer",
        kind: "Customer type",
        kind_business: "Business",
        kind_private: "Private",
        the_customer: "the customer",
        lines_required: "Add at least one product line.",
        one_time: "One-time amount (excl. VAT)",
        monthly: "Monthly amount (excl. VAT)",
        override: "Override",
        override_cancel: "Use the sum of the lines",
        override_amount: "New one-time amount",
        override_reason: "Reason",
        override_reason_required:
          "Write why the one-time amount is overridden.",
        binding: "Binding period",
        binding_none: "None",
        binding_months: "%{smart_count} mo",
        subscription_start: "Subscription from",
        won_date: "Won date",
        acceptance: "Accepted via",
        acceptance_methods: {
          signed: "Signed agreement",
          email: "Email",
          verbal: "Verbal",
          order: "Order",
        },
        win_reason: "Win reason",
        summary_first_year: "First year: %{total} kr",
        summary_binding: "Over the binding period (%{months} mo): %{total} kr.",
        startup: "Startup",
        project_lead: "Project lead",
        template: "Project template",
        template_none: "No template",
        planned_start: "Planned start",
        planned_launch: "Planned launch",
        org_nr: "Org. no.",
        org_nr_invalid: "The org. no. must have 9 digits.",
        invoice_email: "Invoice email",
        manual_billing:
          "The one-time amount is invoiced manually as agreed with the customer. Mimin creates no invoice or invoice basis for it.",
        next: "What happens now",
        action_customer: "Make %{name} a customer",
        action_project:
          "Create a project from the template “%{template}” with %{smart_count} startup task |||| Create a project from the template “%{template}” with %{smart_count} startup tasks",
        action_project_plain: "Create a project without a template",
        action_subscription:
          "Add the subscription to the customer as a customer product",
        no_recurring: "No recurring lines.",
        action_handover: "Create handover task for",
        billing_owner: "Billing owner",
        action_thanks: "Create thank-you message to %{name}",
        action_thanks_plain: "Create thank-you message",
        no_contact: "The opportunity has no contact person.",
        action_review: "Ask for a review 14 days after launch",
        action_notify: "Notify the team",
        notify_who: "Who should be notified?",
        open_tasks: "Open tasks (%{smart_count})",
        open_tasks_move: "Move to the project",
        open_tasks_complete: "Mark as completed",
        open_tasks_keep: "Keep",
        one_at_a_time: "Mark one opportunity as won at a time.",
        done: "%{name} is marked as won.",
        undo: "Undo",
        undone: "Undone. The opportunity is open again.",
        undo_too_late: "Too late to undo – open the opportunity and reopen it",
        project_failed: "The project was not created.",
        automation_failed: "Some automations after the sale failed.",
      },
      lines: {
        title: "Product lines",
        product: "Product",
        description: "Description",
        quantity: "Quantity",
        price: "Price",
        interval: "Period",
        intervals: {
          one_time: "one-time",
          monthly: "monthly",
          quarterly: "quarterly",
          yearly: "yearly",
        },
        row_label: "%{field} (line %{n})",
        choose_product: "Choose product …",
        remove: "Remove line %{n}",
        add: "Add product",
        edit: "Edit lines",
        save: "Save lines",
        saved: "The product lines are saved",
        empty: "No product lines yet.",
        product_required: "Choose a product from the catalog on every line.",
      },
      drafts: {
        title: "Email drafts",
        open: "Open in email",
        copy: "Copy text",
        copied: "The text is copied",
        copy_failed: "Could not copy the text",
        sent_question: "Did you send the email?",
        log_yes: "Yes, log as contact",
        not_yet: "Not yet",
        logged: "Logged as contact: %{title}",
        to: "To %{email}",
        no_recipient: "No recipient – add it in your email program.",
      },
      reopen: {
        won_footprint: "The sale created %{items}. What do you want to do?",
        won_projects: "%{smart_count} project |||| %{smart_count} projects",
        won_tasks: "%{smart_count} task |||| %{smart_count} tasks",
        won_subscriptions:
          "%{smart_count} subscription |||| %{smart_count} subscriptions",
        and: "and",
        won_project: "Project",
        won_products: "Subscriptions not yet invoiced",
        keep: "Keep",
        archive: "Archive",
        deactivate: "Deactivate",
        won_invoiced:
          "The subscription is invoiced for %{smart_count} month. A credit note must be made in Tripletex. |||| The subscription is invoiced for %{smart_count} months. A credit note must be made in Tripletex.",
      },
    },
  },
};
